import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { ProfileInfo } from "./ProfileInfo";
import { ProfileStats } from "./ProfileStats";

export type ExecutiveType = {
  id: number | string;
  name: string;
  email: string;
  sopAdherence: number;
  objectionHandling: number;
  talkToListenRatio: number;
  projects: {
    count: string;
    names: string;
  };
  pendingActions: string;
  totalMeetings: string;
  activeClients: string;
};

interface SalesExecutiveCardProps {
  executive: ExecutiveType;
}

export function SalesExecutiveCard({ executive }: SalesExecutiveCardProps) {
  
  return (
    <Box 
      as="article" 
      display="flex"
      bg="white"
      borderRadius="lg"
      boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1)"
      overflow="hidden"
      width="100%"
      maxW="570px"
      border="1px solid #E2E8F0"
      position="relative"
      transition="all 0.3s ease"
      _hover={{
        transform: "scale(1.02)", 
        boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.15)",
        borderColor: "#805ad6",
      }}
    >
      <Box display="flex" width="100%" position="relative">
        <ProfileInfo
          name={executive.name}
          email={executive.email}
          sopAdherence={executive.sopAdherence}
          objectionHandling={executive.objectionHandling}
          talkToListenRatio={executive.talkToListenRatio}
        />
        <Box
          position="absolute"
          left="254px"
          top="0"
          bottom="0"
          width="1px"
          bg="gray.100"
          zIndex="1"
        />
        <ProfileStats
          executiveId={executive.id}
          projects={executive.projects}
          pendingActions={executive.pendingActions}
          totalMeetings={executive.totalMeetings}
          activeClients={executive.activeClients}
          name={executive.name}
          email={executive.email}
        />
      </Box>
    </Box>
  );
} 